/*
 * @Date: 2020-09-07 18:07:06
 * @LastEditors: guantingting
 * @LastEditTime: 2021-04-19 09:53:38
 */
// const wx = require('weixin-js-sdk')
import wx from "weixin-js-sdk";
import Cookies from "js-cookie";

// ********************************* 环境判断 **********************************
const source = Cookies.get("source");
export const isAndroid = source === "android";
export const isIOS = source === "ios";
export const isApp = isAndroid || isIOS;
export const isWeixin = /MicroMessenger/i.test(navigator.userAgent);
// 获取微信运行环境
function getWxEnv() {
  return new Promise((resolve) => {
    if (!wx) resolve("wechat");
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        resolve("miniprogram");
      } else {
        resolve("wechat");
      }
    });
  });
}
export const isWechat = async () => isWeixin && (await getWxEnv()) === "wechat";
export const isMiniprogram = async () =>
  isWeixin && (await getWxEnv()) === "miniprogram";
// ******************************** 环境判断 ************************************
/**
 * @description: App参数处理
 * @param {*} initOption
 * @return {*}
 */
export const initOption = (options) => {
  options = options || {};
  options.targetClass = options.targetClass || "";
  options.methodType = options.methodType || "0";
  options.methodName = options.methodName || "";
  options.parm = options.parm || [];
  if (isAndroid) {
    options.methodArgsTypes = options.methodArgsTypes || "t,b";
  }
  return JSON.stringify(options);
};
/**
 * @description: 异步调用App方法
 * @param {*} setNativeInfo
 * @return {*}
 */
export const setNativeInfo = (options) => {
  let str = initOption(options);
  if (isIOS) {
    window.app && window.app.jsNavtiveHandle && window.app.jsNavtiveHandle(str);
  } else {
    window.localjs &&
      window.localjs.invokeNativeMethod &&
      window.localjs.invokeNativeMethod(str);
  }
};
/**
 * @description: 同步调用App方法 并返回结果
 * @param {*} getSyncNativeInfo
 * @return {*}
 */
export const getSyncNativeInfo = (options) => {
  let str = initOption(options);
  if (isIOS) {
    return (
      window.app &&
      window.app.jsNavtiveSyncHandle &&
      window.app.jsNavtiveSyncHandle(str)
    );
  } else {
    return (
      window.localjs &&
      window.localjs.invokeNativeSyncMethod &&
      window.localjs.invokeNativeSyncMethod(str)
    );
  }
};
